import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgVideoCall(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="4 11 52 38"
      fill="none"
      {...props}
    >
      <path
        fill={props.primaryColor}
        stroke={props.primaryColor}
        strokeWidth={1.833}
        d="M27.02 21.75a4.584 4.584 0 1 0-.002 9.168 4.584 4.584 0 0 0 .001-9.168Zm0 .916a3.668 3.668 0 1 1-.002 7.336 3.668 3.668 0 0 1 .001-7.336Zm-7.325 14.207c0-.27.08-.534.23-.758l.068-.094.076-.088c.185-.196.424-.334.687-.396l.048-.011.05-.006.104-.013.055-.007H32.98a1.375 1.375 0 0 1 1.336 1.062l.012.048.006.048.012.105.007.056v.055l.002 5.05v.917H23.225q.213.447.333.918h17.67a3.21 3.21 0 0 0 3.207-3.208V19.458a3.21 3.21 0 0 0-3.208-3.208H12.82a3.21 3.21 0 0 0-3.21 3.208v.013l-.098 6.89c.225.026.46.066.697.133q.114.033.23.075l.09-7.122a2.29 2.29 0 0 1 2.29-2.28h28.408a2.29 2.29 0 0 1 2.292 2.291V40.55a2.29 2.29 0 0 1-2.292 2.292h-5.956v-.917l-.002-5.049-.01-.215a2.29 2.29 0 0 0-2.087-2.069l-.208-.008H21.07a2.29 2.29 0 0 0-2.257 1.892l-.027.213-.008.194v1.726q.472.091.917.272z"
      />
      <path
        stroke={props.primaryColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.75}
        d="M44.563 33.156c.15.261.364.476.621.622l5.898 3.347a1.59 1.59 0 0 0 1.617-.028c.244-.15.446-.363.587-.618s.214-.544.215-.838V23.444c0-.294-.074-.583-.215-.839a1.67 1.67 0 0 0-.587-.618 1.59 1.59 0 0 0-1.617-.03l-5.898 3.348c-.257.146-.472.361-.621.623-.15.261-.229.56-.229.863v5.501c0 .304.079.602.229.864"
      />
      <path
        stroke={props.secondaryColor}
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.833}
        d="M13.444 45.782a13 13 0 0 1-.795-.543 18 18 0 0 1-3.391-3.47 17 17 0 0 1-2.856-5.373 10.6 10.6 0 0 1-.496-3.236 5.6 5.6 0 0 1 .821-3.177c.333-.398.716-.75 1.14-1.05a1.7 1.7 0 0 1 1.273-.383c.46.14.85.45 1.089.866.537.81 1.132 1.554 1.71 2.333.233.269.352.618.331.974-.055.294-.21.559-.439.75-.268.253-.58.474-.882.709a1.45 1.45 0 0 0-.605 1.128c.089.535.302 1.042.621 1.48q.54 1.023 1.152 2.006a12.8 12.8 0 0 0 2.83 3.143 1.2 1.2 0 0 0 1.17.319c.437-.167.841-.413 1.19-.725a1.58 1.58 0 0 1 1.105-.41c.354.072.668.274.878.569.28.32.506.682.76 1.024.253.341.46.591.67.901q.39.465.72.97c.165.295.214.642.136.97a1.98 1.98 0 0 1-.803.915 4.5 4.5 0 0 1-3.7.843 10 10 0 0 1-3.629-1.533Z"
      />
    </svg>
  );
}
export default SvgVideoCall;
